import CompactStatisticNumberSuffix from "./CompactStatisticNumberSuffix"

const CompactStatisticNumber = ({ metricStat, isAsym, isCompact = false, show_delta = true, dynamicFontSizing=false }) => {
  return (
    <div
      style={{
        flex: 1,
        flexDirection: "row",
        display: "flex",
        height: "100%",
        alignItems: "center",
        width: '100%',
        overflow: 'hidden'
      }}
    >
      <div
        style={{
          width: '100%'
        }}
      >
        <CompactStatisticNumberSuffix
          metricStat={metricStat}
          isAsym={metricStat.is_asym}
          isCompact={isCompact}
          show_delta={show_delta}
          dynamicFontSizing={dynamicFontSizing}
        />
      </div>
    </div>
  );
};

export default CompactStatisticNumber